<script setup lang="ts">
import { computed } from 'vue';
import * as icons from "lucide-vue-next"; 

const props = defineProps({
  name: { type: String, default: '' },
  size: Number,
  color: String,
  strokeWidth: Number,
  defaultClass: String,
})

const icon = computed(() => {
  // Ensure the icon name exists in the `icons` object
  const iconName = props.name && (icons as any)[props.name];
  if (!iconName) {
    return icons['VaultIcon'];  // Replace 'DefaultIcon' with a valid fallback icon
  }
  return iconName;
});
</script>

<template>
  <component
    v-if="props.name"
    :is="icon"
    :size="size"
    :color="color"
    :stroke-width="strokeWidth"
    :default-class="defaultClass"
  />
</template>